import adminPanelIcon from "../../assets/icons/admin-icon.svg";
import profileIcon from "../../assets/icons/profile-icon.svg";

import groupsIcon from "../../assets/icons/groups-icon.svg";
import favouriteIcon from "../../assets/icons/fav-icon.svg";
import settingIcon from "../../assets/icons/setting-icon.svg";
import helpCentreIcon from "../../assets/icons/help-icon.svg";
import logOutIcon from "../../assets/icons/logout-icon.svg";
import myTopics from "../../assets/icons/my-topics.svg";
import subscriptionIcon from "../../assets/icons/subscription-icon.svg";
import downloadIcon from "../../assets/icons/download_circle.svg";

// Base lists
export const adminMenuList = [
    { path: "/admin-panel/users-management", label: "Admin panel", icon: adminPanelIcon },
    { path: "/profile/overview", label: "Profile", icon: profileIcon },
    { path: "/profile/favourite-standards", label: "Favourites", icon: favouriteIcon },
    { path: "/profile/owned-standards", label: "Owned Standards", icon: myTopics },
    { path: "/profile/subscriptions", label: "Subscriptions", icon: subscriptionIcon },
    { path: "/profile/downloads", label: "Downloads", icon: downloadIcon },
    { path: "/settings", label: "Settings", icon: settingIcon },
    { path: "/help-centre", label: "Help Centre", icon: helpCentreIcon },
    { path: "/", label: "Sign out", icon: logOutIcon },
];

export const internalUserMenuList = [
    { path: "/profile/overview", label: "Profile", icon: profileIcon },
    { path: "/profile/favourite-standards", label: "Favourites", icon: favouriteIcon },
    { path: "/profile/owned-standards", label: "Owned Standards", icon: myTopics },
    { path: "/profile/subscriptions", label: "Subscriptions", icon: subscriptionIcon },
    { path: "/profile/downloads", label: "Downloads", icon: downloadIcon },
    { path: "/settings", label: "Settings", icon: settingIcon },
    { path: "/help-centre", label: "Help Centre", icon: helpCentreIcon },
    { path: "/", label: "Sign out", icon: logOutIcon },
];

export const externalUserMenuList = [
    { path: "/profile/overview", label: "Profile", icon: profileIcon },
    { path: "/profile/favourite-standards", label: "Favourites", icon: favouriteIcon },
    // { path: "/profile/owned-standards", label: "Owned Standards", icon: myTopics },
    { path: "/profile/subscriptions", label: "Subscriptions", icon: subscriptionIcon },
    { path: "/profile/downloads", label: "Downloads", icon: downloadIcon },
    { path: "/settings", label: "Settings", icon: settingIcon },
    { path: "/help-centre", label: "Help Centre", icon: helpCentreIcon },
    { path: "/", label: "Sign out", icon: logOutIcon },
];


